import cx from 'classnames'

type Props = {
  title: React.ReactNode
  highlighted: boolean
}

export const Title = ({title, highlighted}: Props) => {
  return <div className={cx('font-bold', highlighted ? '' : 'text-gray-0')}>{title}</div>
}
